import { Component, Input, OnInit } from '@angular/core';

import { RouterModule } from '@angular/router';
import { ModuloEnum } from '../../enums/modulo.enum';
import { AuthService } from '../../services/apis/usuario-admin/auth.service';
import { Funcionalidade } from '../../services/models/usuario-admin/funcionalidade.model';

@Component({
  selector: 'app-lista-funcionalidade',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './lista-funcionalidade.component.html',
  styleUrls: ['./lista-funcionalidade.component.css'], // Reutilizando o mesmo CSS!
})
export class ListaFuncionalidadeComponent implements OnInit {
  @Input({ required: true }) moduloEnum: ModuloEnum;

  public listaFuncionalidades: Funcionalidade[] = [];

  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    // Busca as funcionalidades e filtra por módulo, assim como o funcionalidades.component faz
    const usuarioLoginResponse = this.authService.getUserInfos();
    if (usuarioLoginResponse && usuarioLoginResponse.listaFuncionalidades) {
      this.listaFuncionalidades = usuarioLoginResponse.listaFuncionalidades.filter(
        f => f.idModulo == this.moduloEnum
      );
    }
  }
}
